import { render, staticRenderFns } from "./IconAuthor.vue?vue&type=template&id=2ded091e&scoped=true"
import script from "./IconAuthor.vue?vue&type=script&lang=js"
export * from "./IconAuthor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ded091e",
  null
  
)

export default component.exports